import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import renderHTML from 'react-render-html';
import { getValue, setValueWithExpire } from '../../../utils/localStorage';
import { isEmpty, findIndex } from '../../../utils/lodash';
import I18n from '../../../config/locales';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: '0px 0px 8px #00000029',
    marginTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(0.25)
  },
  header: {
    color: '#43425D',
    fontSize: 15,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    padding: theme.spacing(1, 2, 0.5)
  },
  announcement: {
    background: '#FFFDE3 0% 0% no-repeat padding-box',
    borderRadius: 0,
    color: '#43425de6',
    fontSize: 15,
    letterSpacing: 0,
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.75, 1),
    display: 'flex',
    justifyContent: 'space-between',
    '& *': {
      fontSize: 15,
      letterSpacing: 0,
      color: '#43425de6',
      '& a': {
        color: theme.palette.tertiary.main
      }
    }
  },
  closeButton: {
    opacity: 0.7
  }
}));

const Announcements = props => {
  const classes = useStyles();
  const [ bannerNotice, updateBannerNotice ] = useState(props.bannerNotice || []);
  const handleOnClose = noticeId => {
    setValueWithExpire(`notice-${noticeId}`, true, { expires: 365, path: '/' });
    const noticeIndex = findIndex(bannerNotice, notice => notice.id === noticeId);
    if (noticeIndex > -1) {
      const data = bannerNotice;
      data.splice(noticeIndex, 1);
      updateBannerNotice([ ...data ]);
    }
  };
  if (isEmpty(bannerNotice)) {
    return <Fragment />;
  }
  return (
    <Box className={classes.root} id="announcementsBox">
      <Typography className={classes.header}>{I18n.t('dashboard.announcements')}</Typography>
      {bannerNotice.map(notice => {
        const { id, dismissable = false, message = '' } = notice;
        const isDismissedNotice = getValue(`notice-${id}`);
        if (isDismissedNotice) {
          return <React.Fragment key={id} />;
        } else {
          return (
            <Box className={classes.announcement} key={id}>
              <Typography>{renderHTML(message)}</Typography>
              {dismissable && (
                <IconButton
                  className={classes.closeButton}
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => handleOnClose(id)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              )}
            </Box>
          );
        }
      })}
    </Box>
  );
};

export default Announcements;
